import styles from "./ViewStatistics.module.scss";
import { AppTooltip } from "../../common/components/tooltip/AppTooltip";
import { RenderWhen } from "../../common/infrastructure/components/RenderWhen";
import { IStatisticItem } from "./models/statisticItem";
import { classNames } from "primereact/utils";

interface IViewStatisticsItemProps {
  item: IStatisticItem;
  onClick: (key: string) => void;
}

export const ViewStatisticsItem = ({
  item,
  onClick,
}: IViewStatisticsItemProps) => {
  return (
    <>
      <p
        className={classNames(styles.root_info_section_pair_left, {
          [styles.root_info_section_pair_left_link]:
            !!item.key && item.detailedItemsMetadata.length > 0,
        })}
        onClick={
          item.detailedItemsMetadata.length > 0
            ? () => onClick(item.key)
            : undefined
        }
      >
        <span>{item.name}</span>
        <RenderWhen condition={!!item.tooltip && !item.value}>
          <AppTooltip
            content={item.tooltip}
            className={styles.root_info_section_pair_left_tooltip}
          />
        </RenderWhen>
      </p>
      <p className={styles.root_info_section_pair_right}>
        {item.value}
        <RenderWhen condition={!!item.tooltip && !!item.value}>
          <AppTooltip
            content={item.tooltip}
            className={styles.root_info_section_pair_left_tooltip}
          />
        </RenderWhen>
      </p>
    </>
  );
};
